import {CreateProps} from "react-admin";
import {NotificationChatIdForm} from "./NotificationChatIdForm";
import {DefaultEdit} from "../components/DefaultEdit";


export const NotificationChatIdEdit = (props: CreateProps) => {
    return (
        <DefaultEdit {...props}>
            <NotificationChatIdForm />
        </DefaultEdit>
    )
}